export const installmentsList = [
  [3, 300.00, 5],
  [6, 600.00, 7.5],
  [9, 900.00, 10],
  [12, 1200.00, 12.5],
  [18, 1800.00, 17.5],
  [24, 2400.00, 22.5],
];
